exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chartWithOverlay[data-v-a1a1334a] {\n  /*  position: relative; */\n    left: 20px;\n    top: 20px;\n    display: block;\n    margin-bottom: 20px;\n}\n#text[data-v-a1a1334a] {\n  width: 100%;\n}\n#append[data-v-a1a1334a] {\n  padding-bottom: 30px;\n}\n.text[data-v-a1a1334a] {\n  padding: 5px 0;\n}\nem[data-v-a1a1334a] {\n  font-weight: 500\n}\n\n", ""]);

// exports
